module.exports = __webpack_public_path__ + "media/images/flags/4x3/zmb-2d02ca9d780e1f949fb45dd1ce06c62b.svg";